<template>
  <div class="d-print-none">
    <div class="navbar nav-top-border navbar-light navbar-expand-lg">

      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <m-a class="navbar-brand navbar-brand-sm navbar-toggler border-0" href="#">
        <m-a :href="{name:'Home'}">
          <m-img :src="findAttributeOnSiteInfo('icon')[0]" height="130"/>
        </m-a>
      </m-a>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">


        <m-a class="navbar-brand navbar-brand-general d-none d-lg-block" href="#">
          <m-a :href="{name:'Home'}">
            <m-img :src="findAttributeOnSiteInfo('icon')[0]" height="130"/>
          </m-a>
        </m-a>

        <template v-for="menu in storeMenus" :key="menu.id">
          <template v-if="menu.position === 'store_nav'">
            <ul class="navbar-nav mr-4">
              <NavMenuItem v-for="item in menu.children" :item="item" :class="`navbar-nav-menu-${item.id}`" :key="item.id"/>
            </ul>
          </template>
        </template>

        <ul class="navbar-nav text-center align-items-center mr-auto">

          <li class="nav-item nav-link p-1 ">
            <m-language-changer1/>
          </li>
          <li class="nav-item nav-link p-1 ">
            <m-a :href="dashboardLink" v-if="isAuth" class="nav-link">
              <button type="button" class="btn btn-primary rounded-pill">{{ dashboardButtonText }}</button>
            </m-a>
            <m-a :href="AuthLink" v-else class="nav-link">
              <button type="button" class="btn btn-primary rounded-pill">{{ dashboardButtonText }}</button>
            </m-a>
          </li>
          <m-search-input-2/>
          <div v-if="shoppingCart">

            <li v-if="isAuth  || findAttributeOnSiteInfo('cartType') == 1" class="nav-link p-1 ">

              <router-link class="text-decoration-none " :to="{name:'ShoppingCart'}">
                <button class="btn d-flex btn-secondary rounded-pill align-items-center position-relative">
                  <i class="bi bi-cart-fill"></i>
                  <m-shopping-cart-counter1/>
                </button>
              </router-link>

            </li>

            <li v-else class="nav-link p-1 ">
              <router-link class="text-decoration-none" :to="{ name: 'UnAuthenticatedShoppingCart' }">
                <button class="btn d-flex btn-secondary align-items-center position-relative rounded-pill">
                  <i class="bi bi-cart-fill"></i>
                  <m-shopping-cart-counter1/>
                </button>
              </router-link>
            </li>

          </div>
        </ul>


      </div>


    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import NavMenuItem from "./NavMenuItem";
import mImg from '../../Tags/Img'
import mA from '../../Tags/A'
import mIcon from '../../Icons/Icon'
import mLanguageChanger1 from "../../Language/LanguageChanger/LanguageChanger1";
import mSearchInput2 from "../../Search/Input/SearchInput2";
import mShoppingCartCounter1 from "../../ShoppingCart/ShoppingCartCounter/ShoppingCartCounter1";

export default {
  name: "Nav2",
  props: {
    shoppingCart: {
      type: Boolean,
      default: true,
    },
    dashboardLink: {
      default: 'https://mixitweb.com'
    },
    AuthLink: {
      default: {name: 'Login'}
    }
  },
  components: {NavMenuItem, mImg, mIcon, mA, mLanguageChanger1, mSearchInput2, mShoppingCartCounter1,},
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      storeMenus: "Menu/getAllMenus",
      isAuth: "User/isAuthenticated",
      orderCount: 'ShoppingCart/getSidebarBasketData',
    }),
    dashboardButtonText() {
      if (!this.isAuth) {
        return this.$t('nav.dashboard_un_auth')
      }
      return this.$t('nav.dashboard_auth')
    }
  },
};
</script>

<style scoped>
.nav-logo {
  height: 60px;
}

.navbar-brand img {
  height: 45px;
}
</style>